module.exports = __webpack_public_path__ + "static/020-f21b6703c892d3a87deeb91e6f34c548.jpg";